import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  TEACHING_WORKLOAD_APPROVAL_ALL,
  TEACHING_WORKLOAD_APPROVAL_BY_ID,
  TEACHING_WORKLOAD_APPROVAL_SUBMIT,
} from '../constants/actionTypes'

const teachingWorkloadSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const teachingWorkloadApprovalAllSelector = createSelector(
  teachingWorkloadSelectors,
  data => data[TEACHING_WORKLOAD_APPROVAL_ALL]
)

export const teachingWorkloadApprovalByIDSelector = createSelector(
  teachingWorkloadSelectors,
  data => data[TEACHING_WORKLOAD_APPROVAL_BY_ID]
)

export const teachingWorkloadApprovalSubmitSelector = createSelector(
  teachingWorkloadSelectors,
  data => data[TEACHING_WORKLOAD_APPROVAL_SUBMIT]
)

export const teachingWorkloadApprovalResponseSelector = createSelector(
  teachingWorkloadSelectors,
  data => data[TEACHING_WORKLOAD_APPROVAL_SUBMIT]
)
